<script lang="ts">
  /**
   * Multiple 'SingleCollectionTime'-rules togehter
   */
  import { Stores, UIEventSource } from "../../../../Logic/UIEventSource"
  import SingleCollectionTime from "./SingleCollectionTime.svelte"
  import { TrashIcon } from "@rgossiaux/svelte-heroicons/solid"
  import { Lists } from "../../../../Utils/Lists"

  export let value: UIEventSource<string>

  let initialRules: string[] = Lists.noEmpty(value.data?.split(";")?.map((v) => v.trim()))
  let singleRules: UIEventSource<UIEventSource<string>[]> = new UIEventSource(
    initialRules?.map((v) => new UIEventSource(v)) ?? []
  )
  if (singleRules.data.length === 0) {
    singleRules.data.push(new UIEventSource(undefined))
  }
  singleRules
    .bindD((stores) => Stores.concat(stores))
    .addCallbackAndRunD((subrules) => {
      console.log("Setting subrules", subrules)
      value.set(Lists.noEmpty(subrules).join("; "))
    })

  function rm(rule: UIEventSource) {
    const index = singleRules.data.indexOf(rule)
    singleRules.data.splice(index, 1)
    singleRules.ping()
  }
</script>

<div class="interactive">
  {#each $singleRules as rule}
    <SingleCollectionTime value={rule}>
      <svelte:fragment slot="right">
        {#if $singleRules.length > 1}
          <button
            on:click={() => {
              rm(rule)
            }}
            class="as-link"
          >
            <TrashIcon class="h-6 w-6" />
          </button>
        {/if}
      </svelte:fragment>
    </SingleCollectionTime>
  {/each}
  <button
    on:click={() => {
      singleRules.data.push(new UIEventSource(undefined))
      singleRules.ping()
    }}
  >
    Add schedule
  </button>
</div>
